import {onBeforeMount} from 'vue';
import {SetupLinkIndexReturn} from '../../common/LinkIndex';
import {SpreadsheetPanelInitLayoutData} from '../../../../types';
export interface SpreadsheetPanelProps {
	panelId: string;
	init_layout_data: SpreadsheetPanelInitLayoutData;
}

export function SetupLayoutData(props: SpreadsheetPanelProps, setupLinkIndexReturn: SetupLinkIndexReturn) {
	onBeforeMount(() => {
		fromJSON(props.init_layout_data);
	});

	function fromJSON(json: SpreadsheetPanelInitLayoutData) {
		setupLinkIndexReturn.fromJSON(json);
	}

	function layoutData() {
		return {
			...setupLinkIndexReturn.toJSON(),
		};
	}

	return {fromJSON, layoutData};
}
